import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, computed } from 'vue'
import { Dialog } from 'vant'
import $http  from '@/plugins/http'
import { useRoute, useRouter} from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const $store: any = inject("$store")
const is_app = $store.getIsApp()
const app_token = computed(() => {
  return common.getStorage('access_token')
})
const router: any = useRouter();
const route: any = useRoute()


// 领取成功跳转首页
const act_home_fn = function () {
  if(is_app) {
    try {
      window.appBean.appHome()
    } catch (error) {} 
  } else {
    router.push("/home");
  }
}
const params = {
  vid: route.params.id
}

// 判断如果未登陆， 跳转登陆
if(!app_token.value) {
  if(is_app) {
    try {
      window.appBean.login('web')
    } catch (error) {} 
  } else {
    router.push("/login?refer=voucher/" + route.params.id)
  }
} else {

  const init_fn = async () => {
    const res = await $http.postVoucher(params)
    if (res.code == 200) {
      Dialog({
        message: 'Successfully received, check it in Account>>Vouchers',
        confirmButtonText: 'ok'
      }).then(() => {
        act_home_fn()
      });
    } else {
      Dialog({
        message: res.datas.error,
        confirmButtonText: 'ok'
      }).then(() => {
        act_home_fn()
      })
    }
  }
  init_fn()
}







return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})